import IconButton from "components/IconButton"
import * as actions from "app/redux/notifications/notifications.actions"
import InfoIcon from "components/Icons/Alert/Info"
import Check from "components/Icons/Check.icon"
import Close from "components/Icons/Close.icon"
import SVGIcon from "components/Icons/SVGIcon"
import Translation from "components/Translation"
import React, { Dispatch, memo } from "react"
import { connect } from "react-redux"
import { Action } from "redux"
import {
  ActionContainer,
  MessageContainer,
  MessageIcon,
  MessageSpan,
  StyledSnackbar,
  StyledSnackbarContent,
  StyledTypography,
} from "./style"

type DispatchProps = {
  hide: (id: string) => void
}

type Props = {
  hide: (id: string) => void
  id: string
  message: string
  values?: {}
  state: string
}

function Notification(props: Props) {
  const { hide, id, message, values, state } = props

  const handleOnClose = () => {
    hide(id)
  }

  const iconVariant = (code: string) => {
    switch (code) {
      case "success":
        return <Check />
      case "error":
        return <SVGIcon width={36} height={36} path="svg-conflict" />
      case "info":
        return <InfoIcon className="SnackbarIcon" />
      default:
    }
  }

  return (
    <StyledSnackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={true}
      autoHideDuration={5000}
      onClose={handleOnClose}
      ContentProps={{
        "aria-describedby": id,
      }}
    >
      <StyledSnackbarContent
        message={
          <MessageContainer>
            <MessageIcon>{iconVariant(state)}</MessageIcon>
            <MessageSpan>
              <StyledTypography state={state}>
                {values && Object.keys(values).length > 0 ? (
                  <Translation label={message} values={values} />
                ) : (
                  <Translation label={message} />
                )}
              </StyledTypography>
            </MessageSpan>
          </MessageContainer>
        }
        state={state}
        action={
          <ActionContainer>
            <IconButton key={`close-${id}`} aria-label="Close" color="inherit" onClick={handleOnClose}>
              <Close />
            </IconButton>
          </ActionContainer>
        }
      />
    </StyledSnackbar>
  )
}

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => ({
  hide: (id: string) => {
    dispatch(actions.hide(id))
  },
})

export default connect(null, mapDispatchToProps)(memo(Notification))
